import {onErrorAlert, onSuccessAlert} from "./actions";
import Icon from "@mui/material/Icon";
import React from "react";
import {checkPermission, PERMISSION_DICT} from "./utils/Users_Roles_Permission";
import LocalStorage from "./utils/LocalStorage";
import {checkKittingVisibility} from "./utils/globalFunction";

export const LOCAL_STORAGE_ITEMS = {
  token: 'token',
  username:'username',
  role:'role',
  ownerId:'ownerId',
  keys:'keys',
  menu:'menu',
  permissions:'permissions',
  user_roles:'user_roles',
  sub_username:'sub_username',
  lastUpdateTimestamp:'lastUpdateTimestamp',
  notification:'notification'
}

export const clearAuthStorage = () => {
  LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.token);
  LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.role);
  LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.ownerId);
  LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.keys);
  LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.menu);
  LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.permissions);
  LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.user_roles);
  LocalStorage.removeItem(LOCAL_STORAGE_ITEMS.lastUpdateTimestamp);
};

export const COLUMN_WIDTH ={
  ownerId:110,
  ownerName:130,
  preview:65,
}



export const SORT_ORDER = {
  asc: 'ASC',
  desc: 'DESC'
}


export function hasMoreThanTwoDecimalPlacesOrIsInteger(x) {
  if (typeof x !== 'number') {
    return true;
  }

  const stringValue = x.toString();
  const decimalIndex = stringValue.indexOf('.');
  if (decimalIndex !== -1) {
    // 如果存在小数点
    const decimalPart = stringValue.substring(decimalIndex + 1);
    return decimalPart.length > 2;
  } else {
    // 如果是整数
    return false;
  }
}



const countriesForAddressOld = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo (Democratic Republic of the)' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GE', label: 'Georgia' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia (Federated States of)' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'KP', label: 'North Korea' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn Islands' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russia' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'KR', label: 'South Korea' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SZ', label: 'Swaziland' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syria' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UM', label: 'United States Minor Outlying Islands' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'VG', label: 'British Virgin Islands' },
  { value: 'VI', label: 'U.S. Virgin Islands' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' }
];

export const countriesForAddress = [
  { id: 1, value: "AF", label: "Afghanistan" },
  { id: 2, value: "AL", label: "Albania" },
  { id: 3, value: "DZ", label: "Algeria" },
  { id: 4, value: "AS", label: "American Samoa" },
  { id: 5, value: "AD", label: "Andorra" },
  { id: 6, value: "AO", label: "Angola" },
  { id: 7, value: "AI", label: "Anguilla" },
  { id: 8, value: "AQ", label: "Antarctica" },
  { id: 9, value: "AG", label: "Antigua and Barbuda" },
  { id: 10, value: "AR", label: "Argentina" },
  { id: 11, value: "AM", label: "Armenia" },
  { id: 12, value: "AW", label: "Aruba" },
  { id: 13, value: "AU", label: "Australia" },
  { id: 14, value: "AT", label: "Austria" },
  { id: 15, value: "AZ", label: "Azerbaijan" },
  { id: 16, value: "BS", label: "Bahamas" },
  { id: 17, value: "BH", label: "Bahrain" },
  { id: 18, value: "BD", label: "Bangladesh" },
  { id: 19, value: "BB", label: "Barbados" },
  { id: 20, value: "BY", label: "Belarus" },
  { id: 21, value: "BE", label: "Belgium" },
  { id: 22, value: "BZ", label: "Belize" },
  { id: 23, value: "BJ", label: "Benin" },
  { id: 24, value: "BM", label: "Bermuda" },
  { id: 25, value: "BT", label: "Bhutan" },
  { id: 26, value: "BO", label: "Bolivia, Plurinational State of" },
  { id: 27, value: "BQ", label: "Bonaire, Sint Eustatius and Saba" },
  { id: 28, value: "BA", label: "Bosnia and Herzegovina" },
  { id: 29, value: "BW", label: "Botswana" },
  { id: 30, value: "BV", label: "Bouvet Island" },
  { id: 31, value: "BR", label: "Brazil" },
  { id: 32, value: "IO", label: "British Indian Ocean Territory" },
  { id: 33, value: "BN", label: "Brunei Darussalam" },
  { id: 34, value: "BG", label: "Bulgaria" },
  { id: 35, value: "BF", label: "Burkina Faso" },
  { id: 36, value: "BI", label: "Burundi" },
  { id: 37, value: "KH", label: "Cambodia" },
  { id: 38, value: "CM", label: "Cameroon" },
  { id: 39, value: "CA", label: "Canada" },
  { id: 40, value: "CV", label: "Cape Verde" },
  { id: 41, value: "KY", label: "Cayman Islands" },
  { id: 42, value: "CF", label: "Central African Republic" },
  { id: 43, value: "TD", label: "Chad" },
  { id: 44, value: "CL", label: "Chile" },
  { id: 45, value: "CN", label: "China" },
  { id: 46, value: "CX", label: "Christmas Island" },
  { id: 47, value: "CC", label: "Cocos (Keeling) Islands" },
  { id: 48, value: "CO", label: "Colombia" },
  { id: 49, value: "KM", label: "Comoros" },
  { id: 50, value: "CG", label: "Congo" },
  { id: 51, value: "CD", label: "Congo, the Democratic Republic of the" },
  { id: 52, value: "CK", label: "Cook Islands" },
  { id: 53, value: "CR", label: "Costa Rica" },
  { id: 54, value: "HR", label: "Croatia" },
  { id: 55, value: "CU", label: "Cuba" },
  { id: 56, value: "CW", label: "Curaçao" },
  { id: 57, value: "CY", label: "Cyprus" },
  { id: 58, value: "CZ", label: "Czech Republic" },
  { id: 59, value: "CI", label: "Côte d'Ivoire" },
  { id: 60, value: "DK", label: "Denmark" },
  { id: 61, value: "DJ", label: "Djibouti" },
  { id: 62, value: "DM", label: "Dominica" },
  { id: 63, value: "DO", label: "Dominican Republic" },
  { id: 64, value: "EC", label: "Ecuador" },
  { id: 65, value: "EG", label: "Egypt" },
  { id: 66, value: "SV", label: "El Salvador" },
  { id: 67, value: "GQ", label: "Equatorial Guinea" },
  { id: 68, value: "ER", label: "Eritrea" },
  { id: 69, value: "EE", label: "Estonia" },
  { id: 70, value: "SZ", label: "Eswatini" },
  { id: 71, value: "ET", label: "Ethiopia" },
  { id: 72, value: "FK", label: "Falkland Islands (Malvinas)" },
  { id: 73, value: "FO", label: "Faroe Islands" },
  { id: 74, value: "FJ", label: "Fiji" },
  { id: 75, value: "FI", label: "Finland" },
  { id: 76, value: "FR", label: "France" },
  { id: 77, value: "GF", label: "French Guiana" },
  { id: 78, value: "PF", label: "French Polynesia" },
  { id: 79, value: "TF", label: "French Southern Territories" },
  { id: 80, value: "GA", label: "Gabon" },
  { id: 81, value: "GM", label: "Gambia" },
  { id: 82, value: "GE", label: "Georgia" },
  { id: 83, value: "DE", label: "Germany" },
  { id: 84, value: "GH", label: "Ghana" },
  { id: 85, value: "GI", label: "Gibraltar" },
  { id: 86, value: "GR", label: "Greece" },
  { id: 87, value: "GL", label: "Greenland" },
  { id: 88, value: "GD", label: "Grenada" },
  { id: 89, value: "GP", label: "Guadeloupe" },
  { id: 90, value: "GU", label: "Guam" },
  { id: 91, value: "GT", label: "Guatemala" },
  { id: 92, value: "GG", label: "Guernsey" },
  { id: 93, value: "GN", label: "Guinea" },
  { id: 94, value: "GW", label: "Guinea-Bissau" },
  { id: 95, value: "GY", label: "Guyana" },
  { id: 96, value: "HT", label: "Haiti" },
  { id: 97, value: "HM", label: "Heard Island and McDonald Islands" },
  { id: 98, value: "VA", label: "Holy See (Vatican City State)" },
  { id: 99, value: "HN", label: "Honduras" },
  { id: 100, value: "HK", label: "Hong Kong" },
  { id: 101, value: "HU", label: "Hungary" },
  { id: 102, value: "IS", label: "Iceland" },
  { id: 103, value: "IN", label: "India" },
  { id: 104, value: "ID", label: "Indonesia" },
  { id: 105, value: "IR", label: "Iran, Islamic Republic of" },
  { id: 106, value: "IQ", label: "Iraq" },
  { id: 107, value: "IE", label: "Ireland" },
  { id: 108, value: "IM", label: "Isle of Man" },
  { id: 109, value: "IL", label: "Israel" },
  { id: 110, value: "IT", label: "Italy" },
  { id: 111, value: "JM", label: "Jamaica" },
  { id: 112, value: "JP", label: "Japan" },
  { id: 113, value: "JE", label: "Jersey" },
  { id: 114, value: "JO", label: "Jordan" },
  { id: 115, value: "KZ", label: "Kazakhstan" },
  { id: 116, value: "KE", label: "Kenya" },
  { id: 117, value: "KI", label: "Kiribati" },
  { id: 118, value: "KP", label: "Korea, Democratic People's Republic of" },
  { id: 119, value: "KR", label: "Korea, Republic of" },
  { id: 120, value: "KW", label: "Kuwait" },
  { id: 121, value: "KG", label: "Kyrgyzstan" },
  { id: 122, value: "LA", label: "Lao People's Democratic Republic" },
  { id: 123, value: "LV", label: "Latvia" },
  { id: 124, value: "LB", label: "Lebanon" },
  { id: 125, value: "LS", label: "Lesotho" },
  { id: 126, value: "LR", label: "Liberia" },
  { id: 127, value: "LY", label: "Libya" },
  { id: 128, value: "LI", label: "Liechtenstein" },
  { id: 129, value: "LT", label: "Lithuania" },
  { id: 130, value: "LU", label: "Luxembourg" },
  { id: 131, value: "MO", label: "Macao" },
  { id: 132, value: "MK", label: "Macedonia, the Former Yugoslav Republic of" },
  { id: 133, value: "MG", label: "Madagascar" },
  { id: 134, value: "MW", label: "Malawi" },
  { id: 135, value: "MY", label: "Malaysia" },
  { id: 136, value: "MV", label: "Maldives" },
  { id: 137, value: "ML", label: "Mali" },
  { id: 138, value: "MT", label: "Malta" },
  { id: 139, value: "MH", label: "Marshall Islands" },
  { id: 140, value: "MQ", label: "Martinique" },
  { id: 141, value: "MR", label: "Mauritania" },
  { id: 142, value: "MU", label: "Mauritius" },
  { id: 143, value: "YT", label: "Mayotte" },
  { id: 144, value: "MX", label: "Mexico" },
  { id: 145, value: "FM", label: "Micronesia, Federated States of" },
  { id: 146, value: "MD", label: "Moldova, Republic of" },
  { id: 147, value: "MC", label: "Monaco" },
  { id: 148, value: "MN", label: "Mongolia" },
  { id: 149, value: "ME", label: "Montenegro" },
  { id: 150, value: "MS", label: "Montserrat" },
  { id: 151, value: "MA", label: "Morocco" },
  { id: 152, value: "MZ", label: "Mozambique" },
  { id: 153, value: "MM", label: "Myanmar" },
  { id: 154, value: "NA", label: "Namibia" },
  { id: 155, value: "NR", label: "Nauru" },
  { id: 156, value: "NP", label: "Nepal" },
  { id: 157, value: "NL", label: "Netherlands" },
  { id: 158, value: "NC", label: "New Caledonia" },
  { id: 159, value: "NZ", label: "New Zealand" },
  { id: 160, value: "NI", label: "Nicaragua" },
  { id: 161, value: "NE", label: "Niger" },
  { id: 162, value: "NG", label: "Nigeria" },
  { id: 163, value: "NU", label: "Niue" },
  { id: 164, value: "NF", label: "Norfolk Island" },
  { id: 165, value: "MP", label: "Northern Mariana Islands" },
  { id: 166, value: "NO", label: "Norway" },
  { id: 167, value: "OM", label: "Oman" },
  { id: 168, value: "PK", label: "Pakistan" },
  { id: 169, value: "PW", label: "Palau" },
  { id: 170, value: "PS", label: "Palestine, State of" },
  { id: 171, value: "PA", label: "Panama" },
  { id: 172, value: "PG", label: "Papua New Guinea" },
  { id: 173, value: "PY", label: "Paraguay" },
  { id: 174, value: "PE", label: "Peru" },
  { id: 175, value: "PH", label: "Philippines" },
  { id: 176, value: "PN", label: "Pitcairn" },
  { id: 177, value: "PL", label: "Poland" },
  { id: 178, value: "PT", label: "Portugal" },
  { id: 179, value: "PR", label: "Puerto Rico" },
  { id: 180, value: "QA", label: "Qatar" },
  { id: 181, value: "RO", label: "Romania" },
  { id: 182, value: "RU", label: "Russian Federation" },
  { id: 183, value: "RW", label: "Rwanda" },
  { id: 184, value: "RE", label: "Réunion" },
  { id: 185, value: "BL", label: "Saint Barthélemy" },
  { id: 186, value: "SH", label: "Saint Helena, Ascension and Tristan da Cunha" },
  { id: 187, value: "KN", label: "Saint Kitts and Nevis" },
  { id: 188, value: "LC", label: "Saint Lucia" },
  { id: 189, value: "MF", label: "Saint Martin (French part)" },
  { id: 190, value: "PM", label: "Saint Pierre and Miquelon" },
  { id: 191, value: "VC", label: "Saint Vincent and the Grenadines" },
  { id: 192, value: "WS", label: "Samoa" },
  { id: 193, value: "SM", label: "San Marino" },
  { id: 194, value: "ST", label: "Sao Tome and Principe" },
  { id: 195, value: "SA", label: "Saudi Arabia" },
  { id: 196, value: "SN", label: "Senegal" },
  { id: 197, value: "RS", label: "Serbia" },
  { id: 198, value: "SC", label: "Seychelles" },
  { id: 199, value: "SL", label: "Sierra Leone" },
  { id: 200, value: "SG", label: "Singapore" },
  { id: 201, value: "SX", label: "Sint Maarten (Dutch part)" },
  { id: 202, value: "SK", label: "Slovakia" },
  { id: 203, value: "SI", label: "Slovenia" },
  { id: 204, value: "SB", label: "Solomon Islands" },
  { id: 205, value: "SO", label: "Somalia" },
  { id: 206, value: "ZA", label: "South Africa" },
  { id: 207, value: "GS", label: "South Georgia and the South Sandwich Islands" },
  { id: 208, value: "SS", label: "South Sudan" },
  { id: 209, value: "ES", label: "Spain" },
  { id: 210, value: "LK", label: "Sri Lanka" },
  { id: 211, value: "SD", label: "Sudan" },
  { id: 212, value: "SR", label: "Suriname" },
  { id: 213, value: "SJ", label: "Svalbard and Jan Mayen" },
  { id: 214, value: "SE", label: "Sweden" },
  { id: 215, value: "CH", label: "Switzerland" },
  { id: 216, value: "SY", label: "Syrian Arab Republic" },
  { id: 217, value: "TW", label: "Taiwan" },
  { id: 218, value: "TJ", label: "Tajikistan" },
  { id: 219, value: "TZ", label: "Tanzania, United Republic of" },
  { id: 220, value: "TH", label: "Thailand" },
  { id: 221, value: "TL", label: "Timor-Leste" },
  { id: 222, value: "TG", label: "Togo" },
  { id: 223, value: "TK", label: "Tokelau" },
  { id: 224, value: "TO", label: "Tonga" },
  { id: 225, value: "TT", label: "Trinidad and Tobago" },
  { id: 226, value: "TN", label: "Tunisia" },
  { id: 227, value: "TR", label: "Turkey" },
  { id: 228, value: "TM", label: "Turkmenistan" },
  { id: 229, value: "TC", label: "Turks and Caicos Islands" },
  { id: 230, value: "TV", label: "Tuvalu" },
  { id: 231, value: "UG", label: "Uganda" },
  { id: 232, value: "UA", label: "Ukraine" },
  { id: 233, value: "AE", label: "United Arab Emirates" },
  { id: 234, value: "GB", label: "United Kingdom" },
  { id: 235, value: "US", label: "United States of America" },
  { id: 236, value: "UY", label: "Uruguay" },
  { id: 237, value: "UZ", label: "Uzbekistan" },
  { id: 238, value: "VU", label: "Vanuatu" },
  { id: 239, value: "VE", label: "Venezuela (Bolivarian Republic of)" },
  { id: 240, value: "VN", label: "Viet Nam" },
  { id: 241, value: "VG", label: "Virgin Islands (British)" },
  { id: 242, value: "VI", label: "Virgin Islands (U.S.)" },
  { id: 243, value: "WF", label: "Wallis and Futuna" },
  { id: 244, value: "EH", label: "Western Sahara" },
  { id: 245, value: "YE", label: "Yemen" },
  { id: 246, value: "ZM", label: "Zambia" },
  { id: 247, value: "ZW", label: "Zimbabwe" }
];

export const countriesForAddressCN = [
  { id: 1, value: "AF", label: "阿富汗" },
  { id: 2, value: "AL", label: "阿尔巴尼亚" },
  { id: 3, value: "DZ", label: "阿尔及利亚" },
  { id: 4, value: "AS", label: "美属萨摩亚" },
  { id: 5, value: "AD", label: "安道尔" },
  { id: 6, value: "AO", label: "安哥拉" },
  { id: 7, value: "AI", label: "安圭拉" },
  { id: 8, value: "AQ", label: "南极洲" },
  { id: 9, value: "AG", label: "安提瓜和巴布达" },
  { id: 10, value: "AR", label: "阿根廷" },
  { id: 11, value: "AM", label: "亚美尼亚" },
  { id: 12, value: "AW", label: "阿鲁巴" },
  { id: 13, value: "AU", label: "澳大利亚" },
  { id: 14, value: "AT", label: "奥地利" },
  { id: 15, value: "AZ", label: "阿塞拜疆" },
  { id: 16, value: "BS", label: "巴哈马" },
  { id: 17, value: "BH", label: "巴林" },
  { id: 18, value: "BD", label: "孟加拉国" },
  { id: 19, value: "BB", label: "巴巴多斯" },
  { id: 20, value: "BY", label: "白俄罗斯" },
  { id: 21, value: "BE", label: "比利时" },
  { id: 22, value: "BZ", label: "伯利兹" },
  { id: 23, value: "BJ", label: "贝宁" },
  { id: 24, value: "BM", label: "百慕大" },
  { id: 25, value: "BT", label: "不丹" },
  { id: 26, value: "BO", label: "玻利维亚" },
  { id: 27, value: "BQ", label: "博内尔、圣尤斯特歇斯和萨巴" },
  { id: 28, value: "BA", label: "波斯尼亚和黑塞哥维那" },
  { id: 29, value: "BW", label: "博茨瓦纳" },
  { id: 30, value: "BV", label: "布韦岛" },
  { id: 31, value: "BR", label: "巴西" },
  { id: 32, value: "IO", label: "英属印度洋领地" },
  { id: 33, value: "BN", label: "文莱" },
  { id: 34, value: "BG", label: "保加利亚" },
  { id: 35, value: "BF", label: "布基纳法索" },
  { id: 36, value: "BI", label: "布隆迪" },
  { id: 37, value: "KH", label: "柬埔寨" },
  { id: 38, value: "CM", label: "喀麦隆" },
  { id: 39, value: "CA", label: "加拿大" },
  { id: 40, value: "CV", label: "佛得角" },
  { id: 41, value: "KY", label: "开曼群岛" },
  { id: 42, value: "CF", label: "中非共和国" },
  { id: 43, value: "TD", label: "乍得" },
  { id: 44, value: "CL", label: "智利" },
  { id: 45, value: "CN", label: "中国" },
  { id: 46, value: "CX", label: "圣诞岛" },
  { id: 47, value: "CC", label: "科科斯（基林）群岛" },
  { id: 48, value: "CO", label: "哥伦比亚" },
  { id: 49, value: "KM", label: "科摩罗" },
  { id: 50, value: "CG", label: "刚果（布）" },
  { id: 51, value: "CD", label: "刚果（金）" },
  { id: 52, value: "CK", label: "库克群岛" },
  { id: 53, value: "CR", label: "哥斯达黎加" },
  { id: 54, value: "HR", label: "克罗地亚" },
  { id: 55, value: "CU", label: "古巴" },
  { id: 56, value: "CW", label: "库拉索" },
  { id: 57, value: "CY", label: "塞浦路斯" },
  { id: 58, value: "CZ", label: "捷克" },
  { id: 59, value: "CI", label: "科特迪瓦" },
  { id: 60, value: "DK", label: "丹麦" },
  { id: 61, value: "DJ", label: "吉布提" },
  { id: 62, value: "DM", label: "多米尼克" },
  { id: 63, value: "DO", label: "多米尼加共和国" },
  { id: 64, value: "EC", label: "厄瓜多尔" },
  { id: 65, value: "EG", label: "埃及" },
  { id: 66, value: "SV", label: "萨尔瓦多" },
  { id: 67, value: "GQ", label: "赤道几内亚" },
  { id: 68, value: "ER", label: "厄立特里亚" },
  { id: 69, value: "EE", label: "爱沙尼亚" },
  { id: 70, value: "SZ", label: "埃斯瓦蒂尼" },
  { id: 71, value: "ET", label: "埃塞俄比亚" },
  { id: 72, value: "FK", label: "福克兰群岛" },
  { id: 73, value: "FO", label: "法罗群岛" },
  { id: 74, value: "FJ", label: "斐济" },
  { id: 75, value: "FI", label: "芬兰" },
  { id: 76, value: "FR", label: "法国" },
  { id: 77, value: "GF", label: "法属圭亚那" },
  { id: 78, value: "PF", label: "法属波利尼西亚" },
  { id: 79, value: "TF", label: "法属南部领地" },
  { id: 80, value: "GA", label: "加蓬" },
  { id: 81, value: "GM", label: "冈比亚" },
  { id: 82, value: "GE", label: "格鲁吉亚" },
  { id: 83, value: "DE", label: "德国" },
  { id: 84, value: "GH", label: "加纳" },
  { id: 85, value: "GI", label: "直布罗陀" },
  { id: 86, value: "GR", label: "希腊" },
  { id: 87, value: "GL", label: "格陵兰" },
  { id: 88, value: "GD", label: "格林纳达" },
  { id: 89, value: "GP", label: "瓜德罗普" },
  { id: 90, value: "GU", label: "关岛" },
  { id: 91, value: "GT", label: "危地马拉" },
  { id: 92, value: "GG", label: "根西岛" },
  { id: 93, value: "GN", label: "几内亚" },
  { id: 94, value: "GW", label: "几内亚比绍" },
  { id: 95, value: "GY", label: "圭亚那" },
  { id: 96, value: "HT", label: "海地" },
  { id: 97, value: "HM", label: "赫德岛和麦克唐纳岛" },
  { id: 98, value: "VA", label: "梵蒂冈" },
  { id: 99, value: "HN", label: "洪都拉斯" },
  { id: 100, value: "HK", label: "香港" },
  { id: 101, value: "HU", label: "匈牙利" },
  { id: 102, value: "IS", label: "冰岛" },
  { id: 103, value: "IN", label: "印度" },
  { id: 104, value: "ID", label: "印度尼西亚" },
  { id: 105, value: "IR", label: "伊朗" },
  { id: 106, value: "IQ", label: "伊拉克" },
  { id: 107, value: "IE", label: "爱尔兰" },
  { id: 108, value: "IM", label: "马恩岛" },
  { id: 109, value: "IL", label: "以色列" },
  { id: 110, value: "IT", label: "意大利" },
  { id: 111, value: "JM", label: "牙买加" },
  { id: 112, value: "JP", label: "日本" },
  { id: 113, value: "JE", label: "泽西岛" },
  { id: 114, value: "JO", label: "约旦" },
  { id: 115, value: "KZ", label: "哈萨克斯坦" },
  { id: 116, value: "KE", label: "肯尼亚" },
  { id: 117, value: "KI", label: "基里巴斯" },
  { id: 118, value: "KP", label: "朝鲜" },
  { id: 119, value: "KR", label: "韩国" },
  { id: 120, value: "KW", label: "科威特" },
  { id: 121, value: "KG", label: "吉尔吉斯斯坦" },
  { id: 122, value: "LA", label: "老挝" },
  { id: 123, value: "LV", label: "拉脱维亚" },
  { id: 124, value: "LB", label: "黎巴嫩" },
  { id: 125, value: "LS", label: "莱索托" },
  { id: 126, value: "LR", label: "利比里亚" },
  { id: 127, value: "LY", label: "利比亚" },
  { id: 128, value: "LI", label: "列支敦士登" },
  { id: 129, value: "LT", label: "立陶宛" },
  { id: 130, value: "LU", label: "卢森堡" },
  { id: 131, value: "MO", label: "澳门" },
  { id: 132, value: "MK", label: "北马其顿" },
  { id: 133, value: "MG", label: "马达加斯加" },
  { id: 134, value: "MW", label: "马拉维" },
  { id: 135, value: "MY", label: "马来西亚" },
  { id: 136, value: "MV", label: "马尔代夫" },
  { id: 137, value: "ML", label: "马里" },
  { id: 138, value: "MT", label: "马耳他" },
  { id: 139, value: "MH", label: "马绍尔群岛" },
  { id: 140, value: "MQ", label: "马提尼克" },
  { id: 141, value: "MR", label: "毛里塔尼亚" },
  { id: 142, value: "MU", label: "毛里求斯" },
  { id: 143, value: "YT", label: "马约特" },
  { id: 144, value: "MX", label: "墨西哥" },
  { id: 145, value: "FM", label: "密克罗尼西亚" },
  { id: 146, value: "MD", label: "摩尔多瓦" },
  { id: 147, value: "MC", label: "摩纳哥" },
  { id: 148, value: "MN", label: "蒙古" },
  { id: 149, value: "ME", label: "黑山" },
  { id: 150, value: "MS", label: "蒙特塞拉特" },
  { id: 151, value: "MA", label: "摩洛哥" },
  { id: 152, value: "MZ", label: "莫桑比克" },
  { id: 153, value: "MM", label: "缅甸" },
  { id: 154, value: "NA", label: "纳米比亚" },
  { id: 155, value: "NR", label: "瑙鲁" },
  { id: 156, value: "NP", label: "尼泊尔" },
  { id: 157, value: "NL", label: "荷兰" },
  { id: 158, value: "NC", label: "新喀里多尼亚" },
  { id: 159, value: "NZ", label: "新西兰" },
  { id: 160, value: "NI", label: "尼加拉瓜" },
  { id: 161, value: "NE", label: "尼日尔" },
  { id: 162, value: "NG", label: "尼日利亚" },
  { id: 163, value: "NU", label: "纽埃" },
  { id: 164, value: "NF", label: "诺福克岛" },
  { id: 165, value: "MP", label: "北马里亚纳群岛" },
  { id: 166, value: "NO", label: "挪威" },
  { id: 167, value: "OM", label: "阿曼" },
  { id: 168, value: "PK", label: "巴基斯坦" },
  { id: 169, value: "PW", label: "帕劳" },
  { id: 170, value: "PS", label: "巴勒斯坦" },
  { id: 171, value: "PA", label: "巴拿马" },
  { id: 172, value: "PG", label: "巴布亚新几内亚" },
  { id: 173, value: "PY", label: "巴拉圭" },
  { id: 174, value: "PE", label: "秘鲁" },
  { id: 175, value: "PH", label: "菲律宾" },
  { id: 176, value: "PN", label: "皮特凯恩" },
  { id: 177, value: "PL", label: "波兰" },
  { id: 178, value: "PT", label: "葡萄牙" },
  { id: 179, value: "PR", label: "波多黎各" },
  { id: 180, value: "QA", label: "卡塔尔" },
  { id: 181, value: "RO", label: "罗马尼亚" },
  { id: 182, value: "RU", label: "俄罗斯联邦" },
  { id: 183, value: "RW", label: "卢旺达" },
  { id: 184, value: "RE", label: "留尼汪" },
  { id: 185, value: "BL", label: "圣巴泰勒米岛" },
  { id: 186, value: "SH", label: "圣赫勒拿" },
  { id: 187, value: "KN", label: "圣基茨和尼维斯" },
  { id: 188, value: "LC", label: "圣卢西亚" },
  { id: 189, value: "MF", label: "圣马丁岛（法属部分）" },
  { id: 190, value: "PM", label: "圣皮埃尔和密克隆" },
  { id: 191, value: "VC", label: "圣文森特和格林纳丁斯" },
  { id: 192, value: "WS", label: "萨摩亚" },
  { id: 193, value: "SM", label: "圣马力诺" },
  { id: 194, value: "ST", label: "圣多美和普林西比" },
  { id: 195, value: "SA", label: "沙特阿拉伯" },
  { id: 196, value: "SN", label: "塞内加尔" },
  { id: 197, value: "RS", label: "塞尔维亚" },
  { id: 198, value: "SC", label: "塞舌尔" },
  { id: 199, value: "SL", label: "塞拉利昂" },
  { id: 200, value: "SG", label: "新加坡" },
  { id: 201, value: "SX", label: "圣马丁岛（荷属部分）" },
  { id: 202, value: "SK", label: "斯洛伐克" },
  { id: 203, value: "SI", label: "斯洛文尼亚" },
  { id: 204, value: "SB", label: "所罗门群岛" },
  { id: 205, value: "SO", label: "索马里" },
  { id: 206, value: "ZA", label: "南非" },
  { id: 207, value: "GS", label: "南乔治亚岛和南桑威奇群岛" },
  { id: 208, value: "SS", label: "南苏丹" },
  { id: 209, value: "ES", label: "西班牙" },
  { id: 210, value: "LK", label: "斯里兰卡" },
  { id: 211, value: "SD", label: "苏丹" },
  { id: 212, value: "SR", label: "苏里南" },
  { id: 213, value: "SJ", label: "斯瓦尔巴群岛和扬马延岛" },
  { id: 214, value: "SE", label: "瑞典" },
  { id: 215, value: "CH", label: "瑞士" },
  { id: 216, value: "SY", label: "叙利亚" },
  { id: 217, value: "TW", label: "台湾" },
  { id: 218, value: "TJ", label: "塔吉克斯坦" },
  { id: 219, value: "TZ", label: "坦桑尼亚" },
  { id: 220, value: "TH", label: "泰国" },
  { id: 221, value: "TL", label: "东帝汶" },
  { id: 222, value: "TG", label: "多哥" },
  { id: 223, value: "TK", label: "托克劳" },
  { id: 224, value: "TO", label: "汤加" },
  { id: 225, value: "TT", label: "特立尼达和多巴哥" },
  { id: 226, value: "TN", label: "突尼斯" },
  { id: 227, value: "TR", label: "土耳其" },
  { id: 228, value: "TM", label: "土库曼斯坦" },
  { id: 229, value: "TC", label: "特克斯和凯科斯群岛" },
  { id: 230, value: "TV", label: "图瓦卢" },
  { id: 231, value: "UG", label: "乌干达" },
  { id: 232, value: "UA", label: "乌克兰" },
  { id: 233, value: "AE", label: "阿联酋" },
  { id: 234, value: "GB", label: "英国" },
  { id: 235, value: "US", label: "美国" },
  { id: 236, value: "UY", label: "乌拉圭" },
  { id: 237, value: "UZ", label: "乌兹别克斯坦" },
  { id: 238, value: "VU", label: "瓦努阿图" },
  { id: 239, value: "VE", label: "委内瑞拉" },
  { id: 240, value: "VN", label: "越南" },
  { id: 241, value: "VG", label: "英属维尔京群岛" },
  { id: 242, value: "VI", label: "美属维尔京群岛" },
  { id: 243, value: "WF", label: "瓦利斯和富图纳" },
  { id: 244, value: "EH", label: "西撒哈拉" },
  { id: 245, value: "YE", label: "也门" },
  { id: 246, value: "ZM", label: "赞比亚" },
  { id: 247, value: "ZW", label: "津巴布韦" }
];

export const countriesForAddressFR = [
  { id: 1, value: "AF", label: "Afghanistan" },
  { id: 2, value: "AL", label: "Albanie" },
  { id: 3, value: "DZ", label: "Algérie" },
  { id: 4, value: "AS", label: "Samoa américaines" },
  { id: 5, value: "AD", label: "Andorre" },
  { id: 6, value: "AO", label: "Angola" },
  { id: 7, value: "AI", label: "Anguilla" },
  { id: 8, value: "AQ", label: "Antarctique" },
  { id: 9, value: "AG", label: "Antigua-et-Barbuda" },
  { id: 10, value: "AR", label: "Argentine" },
  { id: 11, value: "AM", label: "Arménie" },
  { id: 12, value: "AW", label: "Aruba" },
  { id: 13, value: "AU", label: "Australie" },
  { id: 14, value: "AT", label: "Autriche" },
  { id: 15, value: "AZ", label: "Azerbaïdjan" },
  { id: 16, value: "BS", label: "Bahamas" },
  { id: 17, value: "BH", label: "Bahreïn" },
  { id: 18, value: "BD", label: "Bangladesh" },
  { id: 19, value: "BB", label: "Barbade" },
  { id: 20, value: "BY", label: "Biélorussie" },
  { id: 21, value: "BE", label: "Belgique" },
  { id: 22, value: "BZ", label: "Belize" },
  { id: 23, value: "BJ", label: "Bénin" },
  { id: 24, value: "BM", label: "Bermudes" },
  { id: 25, value: "BT", label: "Bhoutan" },
  { id: 26, value: "BO", label: "Bolivie" },
  { id: 27, value: "BQ", label: "Bonaire, Saint-Eustache et Saba" },
  { id: 28, value: "BA", label: "Bosnie-Herzégovine" },
  { id: 29, value: "BW", label: "Botswana" },
  { id: 30, value: "BV", label: "Île Bouvet" },
  { id: 31, value: "BR", label: "Brésil" },
  { id: 32, value: "IO", label: "Territoire britannique de l'océan Indien" },
  { id: 33, value: "BN", label: "Brunei" },
  { id: 34, value: "BG", label: "Bulgarie" },
  { id: 35, value: "BF", label: "Burkina Faso" },
  { id: 36, value: "BI", label: "Burundi" },
  { id: 37, value: "KH", label: "Cambodge" },
  { id: 38, value: "CM", label: "Cameroun" },
  { id: 39, value: "CA", label: "Canada" },
  { id: 40, value: "CV", label: "Cap-Vert" },
  { id: 41, value: "KY", label: "Îles Caïmans" },
  { id: 42, value: "CF", label: "République centrafricaine" },
  { id: 43, value: "TD", label: "Tchad" },
  { id: 44, value: "CL", label: "Chili" },
  { id: 45, value: "CN", label: "Chine" },
  { id: 46, value: "CX", label: "Île Christmas" },
  { id: 47, value: "CC", label: "Îles Cocos (Keeling)" },
  { id: 48, value: "CO", label: "Colombie" },
  { id: 49, value: "KM", label: "Comores" },
  { id: 50, value: "CG", label: "Congo-Brazzaville" },
  { id: 51, value: "CD", label: "Congo-Kinshasa" },
  { id: 52, value: "CK", label: "Îles Cook" },
  { id: 53, value: "CR", label: "Costa Rica" },
  { id: 54, value: "HR", label: "Croatie" },
  { id: 55, value: "CU", label: "Cuba" },
  { id: 56, value: "CW", label: "Curaçao" },
  { id: 57, value: "CY", label: "Chypre" },
  { id: 58, value: "CZ", label: "Tchéquie" },
  { id: 59, value: "CI", label: "Côte d'Ivoire" },
  { id: 60, value: "DK", label: "Danemark" },
  { id: 61, value: "DJ", label: "Djibouti" },
  { id: 62, value: "DM", label: "Dominique" },
  { id: 63, value: "DO", label: "République dominicaine" },
  { id: 64, value: "EC", label: "Équateur" },
  { id: 65, value: "EG", label: "Égypte" },
  { id: 66, value: "SV", label: "El Salvador" },
  { id: 67, value: "GQ", label: "Guinée équatoriale" },
  { id: 68, value: "ER", label: "Érythrée" },
  { id: 69, value: "EE", label: "Estonie" },
  { id: 70, value: "SZ", label: "Eswatini" },
  { id: 71, value: "ET", label: "Éthiopie" },
  { id: 72, value: "FK", label: "Îles Malouines" },
  { id: 73, value: "FO", label: "Îles Féroé" },
  { id: 74, value: "FJ", label: "Fidji" },
  { id: 75, value: "FI", label: "Finlande" },
  { id: 76, value: "FR", label: "France" },
  { id: 77, value: "GF", label: "Guyane française" },
  { id: 78, value: "PF", label: "Polynésie française" },
  { id: 79, value: "TF", label: "Terres australes françaises" },
  { id: 80, value: "GA", label: "Gabon" },
  { id: 81, value: "GM", label: "Gambie" },
  { id: 82, value: "GE", label: "Géorgie" },
  { id: 83, value: "DE", label: "Allemagne" },
  { id: 84, value: "GH", label: "Ghana" },
  { id: 85, value: "GI", label: "Gibraltar" },
  { id: 86, value: "GR", label: "Grèce" },
  { id: 87, value: "GL", label: "Groenland" },
  { id: 88, value: "GD", label: "Grenade" },
  { id: 89, value: "GP", label: "Guadeloupe" },
  { id: 90, value: "GU", label: "Guam" },
  { id: 91, value: "GT", label: "Guatemala" },
  { id: 92, value: "GG", label: "Guernesey" },
  { id: 93, value: "GN", label: "Guinée" },
  { id: 94, value: "GW", label: "Guinée-Bissau" },
  { id: 95, value: "GY", label: "Guyana" },
  { id: 96, value: "HT", label: "Haïti" },
  { id: 97, value: "HM", label: "Îles Heard-et-MacDonald" },
  { id: 98, value: "VA", label: "Vatican" },
  { id: 99, value: "HN", label: "Honduras" },
  { id: 100, value: "HK", label: "Hong Kong" },
  { id: 101, value: "HU", label: "Hongrie" },
  { id: 102, value: "IS", label: "Islande" },
  { id: 103, value: "IN", label: "Inde" },
  { id: 104, value: "ID", label: "Indonésie" },
  { id: 105, value: "IR", label: "Iran" },
  { id: 106, value: "IQ", label: "Irak" },
  { id: 107, value: "IE", label: "Irlande" },
  { id: 108, value: "IM", label: "Île de Man" },
  { id: 109, value: "IL", label: "Israël" },
  { id: 110, value: "IT", label: "Italie" },
  { id: 111, value: "JM", label: "Jamaïque" },
  { id: 112, value: "JP", label: "Japon" },
  { id: 113, value: "JE", label: "Jersey" },
  { id: 114, value: "JO", label: "Jordanie" },
  { id: 115, value: "KZ", label: "Kazakhstan" },
  { id: 116, value: "KE", label: "Kenya" },
  { id: 117, value: "KI", label: "Kiribati" },
  { id: 118, value: "KP", label: "Corée du Nord" },
  { id: 119, value: "KR", label: "Corée du Sud" },
  { id: 120, value: "KW", label: "Koweït" },
  { id: 121, value: "KG", label: "Kirghizistan" },
  { id: 122, value: "LA", label: "Laos" },
  { id: 123, value: "LV", label: "Lettonie" },
  { id: 124, value: "LB", label: "Liban" },
  { id: 125, value: "LS", label: "Lesotho" },
  { id: 126, value: "LR", label: "Libéria" },
  { id: 127, value: "LY", label: "Libye" },
  { id: 128, value: "LI", label: "Liechtenstein" },
  { id: 129, value: "LT", label: "Lituanie" },
  { id: 130, value: "LU", label: "Luxembourg" },
  { id: 131, value: "MO", label: "Macao" },
  { id: 132, value: "MK", label: "Macédoine du Nord" },
  { id: 133, value: "MG", label: "Madagascar" },
  { id: 134, value: "MW", label: "Malawi" },
  { id: 135, value: "MY", label: "Malaisie" },
  { id: 136, value: "MV", label: "Maldives" },
  { id: 137, value: "ML", label: "Mali" },
  { id: 138, value: "MT", label: "Malte" },
  { id: 139, value: "MH", label: "Îles Marshall" },
  { id: 140, value: "MQ", label: "Martinique" },
  { id: 141, value: "MR", label: "Mauritanie" },
  { id: 142, value: "MU", label: "Maurice" },
  { id: 143, value: "YT", label: "Mayotte" },
  { id: 144, value: "MX", label: "Mexique" },
  { id: 145, value: "FM", label: "Micronésie" },
  { id: 146, value: "MD", label: "Moldavie" },
  { id: 147, value: "MC", label: "Monaco" },
  { id: 148, value: "MN", label: "Mongolie" },
  { id: 149, value: "ME", label: "Monténégro" },
  { id: 150, value: "MS", label: "Montserrat" },
  { id: 151, value: "MA", label: "Maroc" },
  { id: 152, value: "MZ", label: "Mozambique" },
  { id: 153, value: "MM", label: "Myanmar" },
  { id: 154, value: "NA", label: "Namibie" },
  { id: 155, value: "NR", label: "Nauru" },
  { id: 156, value: "NP", label: "Népal" },
  { id: 157, value: "NL", label: "Pays-Bas" },
  { id: 158, value: "NC", label: "Nouvelle-Calédonie" },
  { id: 159, value: "NZ", label: "Nouvelle-Zélande" },
  { id: 160, value: "NI", label: "Nicaragua" },
  { id: 161, value: "NE", label: "Niger" },
  { id: 162, value: "NG", label: "Nigeria" },
  { id: 163, value: "NU", label: "Niue" },
  { id: 164, value: "NF", label: "Île Norfolk" },
  { id: 165, value: "MP", label: "Îles Mariannes du Nord" },
  { id: 166, value: "NO", label: "Norvège" },
  { id: 167, value: "OM", label: "Oman" },
  { id: 168, value: "PK", label: "Pakistan" },
  { id: 169, value: "PW", label: "Palaos" },
  { id: 170, value: "PS", label: "Palestine" },
  { id: 171, value: "PA", label: "Panama" },
  { id: 172, value: "PG", label: "Papouasie-Nouvelle-Guinée" },
  { id: 173, value: "PY", label: "Paraguay" },
  { id: 174, value: "PE", label: "Pérou" },
  { id: 175, value: "PH", label: "Philippines" },
  { id: 176, value: "PN", label: "Îles Pitcairn" },
  { id: 177, value: "PL", label: "Pologne" },
  { id: 178, value: "PT", label: "Portugal" },
  { id: 179, value: "PR", label: "Porto Rico" },
  { id: 180, value: "QA", label: "Qatar" },
  { id: 181, value: "RO", label: "Roumanie" },
  { id: 182, value: "RU", label: "Russie" },
  { id: 183, value: "RW", label: "Rwanda" },
  { id: 184, value: "RE", label: "Réunion" },
  { id: 185, value: "BL", label: "Saint-Barthélemy" },
  { id: 186, value: "SH", label: "Sainte-Hélène, Ascension et Tristan da Cunha" },
  { id: 187, value: "KN", label: "Saint-Kitts-et-Nevis" },
  { id: 188, value: "LC", label: "Sainte-Lucie" },
  { id: 189, value: "MF", label: "Saint-Martin (partie française)" },
  { id: 190, value: "PM", label: "Saint-Pierre-et-Miquelon" },
  { id: 191, value: "VC", label: "Saint-Vincent-et-les-Grenadines" },
  { id: 192, value: "WS", label: "Samoa" },
  { id: 193, value: "SM", label: "Saint-Marin" },
  { id: 194, value: "ST", label: "Sao Tomé-et-Principe" },
  { id: 195, value: "SA", label: "Arabie saoudite" },
  { id: 196, value: "SN", label: "Sénégal" },
  { id: 197, value: "RS", label: "Serbie" },
  { id: 198, value: "SC", label: "Seychelles" },
  { id: 199, value: "SL", label: "Sierra Leone" },
  { id: 200, value: "SG", label: "Singapour" },
  { id: 201, value: "SX", label: "Saint-Martin (partie néerlandaise)" },
  { id: 202, value: "SK", label: "Slovaquie" },
  { id: 203, value: "SI", label: "Slovénie" },
  { id: 204, value: "SB", label: "Îles Salomon" },
  { id: 205, value: "SO", label: "Somalie" },
  { id: 206, value: "ZA", label: "Afrique du Sud" },
  { id: 207, value: "GS", label: "Géorgie du Sud-et-les Îles Sandwich du Sud" },
  { id: 208, value: "SS", label: "Soudan du Sud" },
  { id: 209, value: "ES", label: "Espagne" },
  { id: 210, value: "LK", label: "Sri Lanka" },
  { id: 211, value: "SD", label: "Soudan" },
  { id: 212, value: "SR", label: "Suriname" },
  { id: 213, value: "SJ", label: "Svalbard et Île Jan Mayen" },
  { id: 214, value: "SE", label: "Suède" },
  { id: 215, value: "CH", label: "Suisse" },
  { id: 216, value: "SY", label: "Syrie" },
  { id: 217, value: "TW", label: "Taïwan" },
  { id: 218, value: "TJ", label: "Tadjikistan" },
  { id: 219, value: "TZ", label: "Tanzanie" },
  { id: 220, value: "TH", label: "Thaïlande" },
  { id: 221, value: "TL", label: "Timor oriental" },
  { id: 222, value: "TG", label: "Togo" },
  { id: 223, value: "TK", label: "Tokelau" },
  { id: 224, value: "TO", label: "Tonga" },
  { id: 225, value: "TT", label: "Trinité-et-Tobago" },
  { id: 226, value: "TN", label: "Tunisie" },
  { id: 227, value: "TR", label: "Turquie" },
  { id: 228, value: "TM", label: "Turkménistan" },
  { id: 229, value: "TC", label: "Îles Turques-et-Caïques" },
  { id: 230, value: "TV", label: "Tuvalu" },
  { id: 231, value: "UG", label: "Ouganda" },
  { id: 232, value: "UA", label: "Ukraine" },
  { id: 233, value: "AE", label: "Émirats arabes unis" },
  { id: 234, value: "GB", label: "Royaume-Uni" },
  { id: 235, value: "US", label: "États-Unis" },
  { id: 236, value: "UY", label: "Uruguay" },
  { id: 237, value: "UZ", label: "Ouzbékistan" },
  { id: 238, value: "VU", label: "Vanuatu" },
  { id: 239, value: "VE", label: "Venezuela" },
  { id: 240, value: "VN", label: "Viêt Nam" },
  { id: 241, value: "VG", label: "Îles Vierges britanniques" },
  { id: 242, value: "VI", label: "Îles Vierges des États-Unis" },
  { id: 243, value: "WF", label: "Wallis-et-Futuna" },
  { id: 244, value: "EH", label: "Sahara occidental" },
  { id: 245, value: "YE", label: "Yémen" },
  { id: 246, value: "ZM", label: "Zambie" },
  { id: 247, value: "ZW", label: "Zimbabwe" }
];

export const countriesForCustomerImport = [
  "Canada",
  "United States",
  "Andorra",
  "United Arab Emirates",
  "Afghanistan",
  "Antigua and Barbuda",
  "Anguilla",
  "Albania",
  "Armenia",
  "Netherlands Antilles",
  "Angola",
  "Argentina",
  "Austria",
  "Australia",
  "Aruba",
  "Azerbaijan",
  "Bosnia and Herzegovina",
  "Barbados",
  "Bangladesh",
  "Belgium",
  "Burkina Faso",
  "Bulgaria",
  "Bahrain",
  "Burundi",
  "Benin",
  "Bermuda",
  "Brunei Darussalam",
  "Bolivia",
  "Brazil",
  "Bahamas",
  "Bhutan",
  "Bouvet Island",
  "Botswana",
  "Belarus",
  "Belize",
  "Central African Republic",
  "Congo",
  "Switzerland",
  "Cook Islands",
  "Chile",
  "Cameroon",
  "China",
  "Colombia",
  "Costa Rica",
  "Cuba",
  "Cape Verde",
  "Christmas Island",
  "Cyprus",
  "Czechia",
  "Germany",
  "Djibouti",
  "Denmark",
  "Dominica",
  "Dominican Republic",
  "Algeria",
  "Ecuador",
  "Estonia",
  "Egypt",
  "Western Sahara",
  "Eritrea",
  "Spain",
  "Ethiopia",
  "Finland",
  "Fiji",
  "Micronesia",
  "Faroe Islands",
  "France",
  "Gabon",
  "United Kingdom",
  "Grenada",
  "Georgia",
  "French Guiana",
  "Ghana",
  "Gibraltar",
  "Greenland",
  "Gambia",
  "Guinea",
  "Guadeloupe",
  "Equatorial Guinea",
  "Greece",
  "Guatemala",
  "Guam",
  "Guinea-Bissau",
  "Guyana",
  "Hong Kong",
  "Honduras",
  "Croatia",
  "Haiti",
  "Hungary",
  "Indonesia",
  "Ireland",
  "Israel",
  "India",
  "British Indian Ocean Territory",
  "Iraq",
  "Iran",
  "Iceland",
  "Italy",
  "Jamaica",
  "Jordan",
  "Japan",
  "Kenya",
  "Kyrgyzstan",
  "Cambodia",
  "Kiribati",
  "Comoros",
  "North Korea",
  "South Korea",
  "Kuwait",
  "Cayman Islands",
  "Kazakhstan",
  "Lao Peoples Democratic Republic",
  "Lebanon",
  "Saint Lucia",
  "Liechtenstein",
  "Sri Lanka",
  "Liberia",
  "Lesotho",
  "Lithuania",
  "Luxembourg",
  "Latvia",
  "Morocco",
  "Monaco",
  "Moldova",
  "Montenegro",
  "Madagascar",
  "Marshall Islands",
  "Macedonia",
  "Mali",
  "Myanmar",
  "Mongolia",
  "Macau",
  "Martinique",
  "Mauritania",
  "Montserrat",
  "Malta",
  "Mauritius",
  "Maldives",
  "Malawi",
  "Mexico",
  "Malaysia",
  "Mozambique",
  "Namibia",
  "New Caledonia",
  "Niger",
  "Norfolk Island",
  "Nigeria",
  "Nicaragua",
  "Netherlands",
  "Norway",
  "Nepal",
  "Nauru",
  "Niue",
  "New Zealand",
  "Oman",
  "Panama",
  "Peru",
  "French Polynesia",
  "Papua New Guinea",
  "Philippines",
  "Pakistan",
  "Poland",
  "Pitcairn",
  "Puerto Rico",
  "Palestine",
  "Portugal",
  "Palau",
  "Paraguay",
  "Qatar",
  "Reunion",
  "Romania",
  "Serbia",
  "Russian Federation",
  "Rwanda",
  "Saudi Arabia",
  "Solomon Islands",
  "Seychelles",
  "Sudan",
  "Sweden",
  "Singapore",
  "Slovenia",
  "Slovakia (Slovak Republic)",
  "Sierra Leone",
  "San Marino",
  "Senegal",
  "Somalia",
  "Suriname",
  "Sao Tome and Principe",
  "El Salvador",
  "Syrian Arab Republic",
  "Swaziland",
  "Turks and Caicos Islands",
  "Chad",
  "French Southern Territories",
  "Togo",
  "Thailand",
  "Tajikistan",
  "Tokelau",
  "East Timor",
  "Turkmenistan",
  "Tunisia",
  "Tonga",
  "Turkey",
  "Trinidad and Tobago",
  "Tuvalu",
  "Taiwan",
  "Tanzania",
  "Ukraine",
  "Uganda",
  "Uruguay",
  "Uzbekistan",
  "Vatican City State (Holy See)",
  "Venezuela",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Vietnam",
  "Vanuatu",
  "Wallis And Futuna Islands",
  "Samoa",
  "Kosovo",
  "Yemen",
  "Mayotte",
  "Yugoslavia",
  "South Africa",
  "Zambia",
  "Zimbabwe"
];

export const regionList = [
  // Canada Provinces and Territories
  {province: 'alberta', shortName: 'AB'},
  {province: 'british columbia', shortName: 'BC'},
  {province: 'manitoba', shortName: 'MB'},
  {province: 'new brunswick', shortName: 'NB'},
  {province: 'newfoundland and labrador', shortName: 'NL'},
  {province: 'northwest territories', shortName: 'NT'},
  {province: 'nova scotia', shortName: 'NS'},
  {province: 'nunavut', shortName: 'NU'},
  {province: 'ontario', shortName: 'ON'},
  {province: 'prince edward island', shortName: 'PE'},
  {province: 'quebec', shortName: 'QC'},
  {province: 'québec', shortName: 'QC'},
  {province: 'saskatchewan', shortName: 'SK'},
  {province: 'yukon', shortName: 'YT'},

  // USA States
  {province: 'alabama', shortName: 'AL'},
  {province: 'alaska', shortName: 'AK'},
  {province: 'arizona', shortName: 'AZ'},
  {province: 'arkansas', shortName: 'AR'},
  {province: 'california', shortName: 'CA'},
  {province: 'colorado', shortName: 'CO'},
  {province: 'connecticut', shortName: 'CT'},
  {province: 'delaware', shortName: 'DE'},
  {province: 'florida', shortName: 'FL'},
  {province: 'georgia', shortName: 'GA'},
  {province: 'hawaii', shortName: 'HI'},
  {province: 'idaho', shortName: 'ID'},
  {province: 'illinois', shortName: 'IL'},
  {province: 'indiana', shortName: 'IN'},
  {province: 'iowa', shortName: 'IA'},
  {province: 'kansas', shortName: 'KS'},
  {province: 'kentucky', shortName: 'KY'},
  {province: 'louisiana', shortName: 'LA'},
  {province: 'maine', shortName: 'ME'},
  {province: 'maryland', shortName: 'MD'},
  {province: 'massachusetts', shortName: 'MA'},
  {province: 'michigan', shortName: 'MI'},
  {province: 'minnesota', shortName: 'MN'},
  {province: 'mississippi', shortName: 'MS'},
  {province: 'missouri', shortName: 'MO'},
  {province: 'montana', shortName: 'MT'},
  {province: 'nebraska', shortName: 'NE'},
  {province: 'nevada', shortName: 'NV'},
  {province: 'new hampshire', shortName: 'NH'},
  {province: 'new jersey', shortName: 'NJ'},
  {province: 'new mexico', shortName: 'NM'},
  {province: 'new york', shortName: 'NY'},
  {province: 'north carolina', shortName: 'NC'},
  {province: 'north dakota', shortName: 'ND'},
  {province: 'ohio', shortName: 'OH'},
  {province: 'oklahoma', shortName: 'OK'},
  {province: 'oregon', shortName: 'OR'},
  {province: 'pennsylvania', shortName: 'PA'},
  {province: 'rhode island', shortName: 'RI'},
  {province: 'south carolina', shortName: 'SC'},
  {province: 'south dakota', shortName: 'SD'},
  {province: 'tennessee', shortName: 'TN'},
  {province: 'texas', shortName: 'TX'},
  {province: 'utah', shortName: 'UT'},
  {province: 'vermont', shortName: 'VT'},
  {province: 'virginia', shortName: 'VA'},
  {province: 'washington', shortName: 'WA'},
  {province: 'west virginia', shortName: 'WV'},
  {province: 'wisconsin', shortName: 'WI'},
  {province: 'wyoming', shortName: 'WY'},
  {province: 'chicago', shortName: 'IL'}
];


export const taxCodeList = [
  {
    id: 1,
    taxCode: 'QST - QC',
    countryCode: 'CA',
    rate:9.975,
    noteText:null,
    activeFlag:'OPEN'
  },
  {
    id: 2,
    taxCode: 'GST 5%',
    countryCode: 'CA',
    rate:5.000,
    noteText:null,
    activeFlag:'OPEN'
  },
  {
    id: 3,
    taxCode: 'HST ON',
    countryCode: 'CA',
    rate:13.000,
    noteText:null,
    activeFlag:'OPEN'
  },
  {
    id: 4,
    taxCode: 'Exempt',
    countryCode: 'CA',
    rate:0,
    noteText:null,
    activeFlag:'OPEN'
  },
  {
    id: 5,
    taxCode: 'GST/QST QC - 9.975',
    countryCode: 'CA',
    rate:14.975,
    noteText:null,
    activeFlag:'OPEN'
  },

]

export const returnCarrierIdList = [
  {
    dictLabel: "UPS",
    dictValue: "UPS"
  },
  {
    dictLabel: "Canpar",
    dictValue: "Canpar"
  },
  {
    dictLabel: "Canada Post",
    dictValue: "Canada Post"
  },
  {
    dictLabel: "Federal Express",
    dictValue: "Federal Express"
  },
  {
    dictLabel: "Purolator",
    dictValue: "Purolator"
  },
  {
    dictLabel: "UniUni",
    dictValue: "UniUni"
  },
  {
    dictLabel: "USPS",
    dictValue: "USPS"
  },
  {
    dictLabel: "PYK",
    dictValue: "PYK"
  },
  {
    dictLabel: "DHL",
    dictValue: "DHL"
  },
  {
    dictLabel: "Aramex",
    dictValue: "Aramex"
  },
  {
    dictLabel: "Fleet Optics",
    dictValue: "Fleet Optics"
  },
  {
    dictLabel: "Intelcom",
    dictValue: "Intelcom"
  },
  {
    dictLabel: "APC",
    dictValue: "APC"
  },
  {
    dictLabel: "Parcel",
    dictValue: "Parcel"
  },
]

export const tabsRoutes= () =>{
  return [
    //Inventory Stock
    {
      type: "tab",
      name: "Search Product Information",
      chineseName: "搜索产品信息",
      key: "productInformation",
      icon: <Icon fontSize="small">search</Icon>,
      route: "/inventory/inventory_stock?tab=0",
      parent:"Inventory - Inventory Stock",
      chineseNameParent:"库存管理 - 库存查询",
      localStorageKey:{key:"selectedInventoryStockTab",value:0}
    },
    {
      type: "tab",
      name: "Search Batch Information",
      chineseName: "搜索批次信息",
      key: "batchInformation",
      icon: <Icon fontSize="small">manage_search</Icon>,
      route: "/inventory/inventory_stock?tab=1",
      parent:"Inventory - Inventory Stock",
      chineseNameParent:"库存管理 - 库存查询",
      localStorageKey:{key:"selectedInventoryStockTab",value:1}
    },
    //kit
    {
      type: "tab",
      name: "Kit Mapping",
      chineseName: "套装匹配",
      key: "kitMapping",
      icon: <Icon fontSize="small">manage_search</Icon>,
      route: "/inventory/kit_management?tab=0",
      parent:"Inventory - Kit Management",
      chineseNameParent:"库存管理 - 套装",
      localStorageKey:{key:"selectedKitManagementTab",value:0}
    },

    ...(checkPermission(PERMISSION_DICT.InventoryKittingList) && checkKittingVisibility()
        ? [
          {
            type: "tab",
            name: "Kitting Management",
            chineseName: "套装制作",
            key: "Kitting",
            icon: <Icon fontSize="small">move_to_inbox</Icon>,
            route: "/inventory/kit_management?tab=1",
            parent:"Inventory - Kit Management",
            chineseNameParent:"库存管理 - 包装",
            localStorageKey:{key:"selectedKitManagementTab",value:1}
          },
        ]
        : []),
    //packaging
    {
      type: "tab",
      name: "Search Packaging Information",
      chineseName: "搜索包装信息",
      key: "packagingInformation",
      icon: <Icon fontSize="small">search</Icon>,
      route: "/inventory/packaging?tab=0",
      parent:"Inventory - Packaging",
      chineseNameParent:"库存管理 - 包装",
      localStorageKey:{key:"selectedPackagingTab",value:0}
    },
    {
      type: "tab",
      name: "Invalid Packaging List",
      chineseName: "无效包装清单",
      key: "invalidPackagingList",
      icon: <Icon fontSize="small">report_problem</Icon>,
      route: "/inventory/packaging?tab=1",
      parent:"Inventory - Packaging",
      chineseNameParent:"库存管理 - 包装",
      localStorageKey:{key:"selectedPackagingTab",value:1}
    },




    //account
    {
      type: "tab",
      name: "User Info",
      chineseName: "用户信息",
      key: "userInfo",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/account?tab=0",
      parent:"Account",
      chineseNameParent:"账户",
      localStorageKey:{ key:"selectedAccountTab",value:0}
    },
    {
      type: "tab",
      name: "Password",
      chineseName: "密码",
      key: "password",
      icon: <Icon fontSize="small">password</Icon>,
      route: "/account?tab=1",
      parent:"Account",
      chineseNameParent:"账户",
      localStorageKey:{ key:"selectedAccountTab",value:1}
    },
    ...(checkPermission(PERMISSION_DICT.BillingInvoiceConnect)
        ? [
          {
            type: "tab",
            name: "Connections",
            chineseName: "链接",
            key: "connections",
            icon: <Icon fontSize="small">link</Icon>,
            route: "/account?tab=2",
            parent: "Account",
            chineseNameParent:"账户",
            localStorageKey:{ key:"selectedAccountTab",value:2}
          },
        ]
        : []),
    ...(!checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        ? [
          {
            type: "tab",
            name: "Payment",
            chineseName: "支付",
            key: "payment",
            icon: <Icon fontSize="small">credit_card</Icon>,
            route: "/account?tab=2",
            parent:"Account",
            chineseNameParent:"账户",
            localStorageKey:{ key:"selectedAccountTab",value:2}
          },
        ]
        : []),
    ...(!checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        ? [
          {
            type: "tab",
            name: "Address",
            chineseName: "地址",
            key: "address",
            icon: <Icon fontSize="small">home</Icon>,
            route: "/account?tab=3",
            parent:"Account",
            chineseNameParent:"账户",
            localStorageKey:{ key:"selectedAccountTab",value:3}
          },
        ]
        : []),
    //sales_reports
    {
      type: "tab",
      name: "Sales Summary",
      chineseName:"销售汇总",
      key: "salesSummary",
      icon: <Icon fontSize="small">summarize</Icon>,
      route: "/report/sales_reports?tab=0",
      parent:"Report - Sales Reports",
      chineseNameParent:"报表 - 销售报表",
      localStorageKey:{key:"selectedSalesReportsTab",value:0}
    },
    {
      type: "tab",
      name: "Individual",
      chineseName:"单品",
      key: "individual",
      icon: <Icon fontSize="small"> how_to_reg</Icon>,
      route: "/report/sales_reports?tab=1",
      parent:"Report - Sales Reports",
      chineseNameParent:"报表 - 销售报表",
      localStorageKey:{key:"selectedSalesReportsTab",value:1}
    },
    // {
    //   type: "tab",
    //   name: "Warehouse Area",
    //   chineseName:"仓库",
    //   key: "warehouseArea",
    //   icon: <Icon fontSize="small">warehouse</Icon>,
    //   route: "/report/sales_reports?tab=2",
    //   parent:"Report - Sales Reports",
    //   chineseNameParent:"报表 - 销售报表",
    //   localStorageKey:{key:"selectedSalesReportsTab",value:2}
    // },
    // {
    //   type: "tab",
    //   name: "Batch",
    //   chineseName:"批次",
    //   key: "batch",
    //   icon: <Icon fontSize="small">manage_search</Icon>,
    //   route: "/report/sales_reports?tab=3",
    //   parent:"Report - Sales Reports",
    //   chineseNameParent:"报表 - 销售报表",
    //   localStorageKey:{key:"selectedSalesReportsTab",value:3}
    // },

    //fulfillment_reports
    ...(checkPermission(PERMISSION_DICT.ReportFulfillmentCostDetail)
        ? [
          {
            type: "tab",
            name: "Cost Details",
            chineseName:"成本明细",
            key: "costDetails",
            icon: <Icon fontSize="small">manage_search</Icon>,
            route: "/report/fulfillment_reports?tab=0",
            parent:"Report - Fulfillment Reports",
            chineseNameParent:"报表 - 履约报表",
            localStorageKey:{key:"selectedFulfillmentReportsTab",value:0}
          },
        ]
        : []),
    ...(checkPermission(PERMISSION_DICT.ReportFulfillmentCost) && checkPermission(PERMISSION_DICT.ReportFulfillmentCostDetail)
        ? [
          {
            type: "tab",
            name: "Cost Summary",
            chineseName:"成本汇总",
            key: "costSummary",
            icon: <Icon fontSize="small">manage_search</Icon>,
            route: "/report/fulfillment_reports?tab=1",
            parent:"Report - Fulfillment Reports",
            chineseNameParent:"报表 - 履约报表",
            localStorageKey:{key:"selectedFulfillmentReportsTab",value:1}
          },
        ]
        : [ {
          type: "tab",
          name: "Cost Summary",
          chineseName:"成本汇总",
          key: "costSummary",
          icon: <Icon fontSize="small">manage_search</Icon>,
          route: "/report/fulfillment_reports?tab=0",
          parent:"Report - Fulfillment Reports",
          chineseNameParent:"报表 - 履约报表",
          localStorageKey:{key:"selectedFulfillmentReportsTab",value:0}
        }]),

    //inventory_reports
    {
      type: "tab",
      name: "SKU",
      chineseName:"SKU",
      key: "sku",
      icon: <Icon fontSize="small">search</Icon>,
      route: "/report/inventory_reports?tab=0",
      parent:"Report - Inventory Reports",
      chineseNameParent:"报表 - 库存报表",
      localStorageKey:{key:"selectedInventoryReportsTab",value:0}
    },
    {
      type: "tab",
      name: "Batch",
      chineseName:"批次",
      key: "batch",
      icon: <Icon fontSize="small">manage_search</Icon>,
      route: "/report/inventory_reports?tab=1",
      parent:"Report - Inventory Reports",
      chineseNameParent:"报表 - 库存报表",
      localStorageKey:{key:"selectedInventoryReportsTab",value:1}
    },
    {
      type: "tab",
      name: "location",
      chineseName:"库存地址",
      key: "Location",
      icon: <Icon fontSize="small">pin_drop</Icon>,
      route: "/report/inventory_reports?tab=4",
      parent:"Report - Inventory Reports",
      chineseNameParent:"报表 - 库存报表",
      localStorageKey:{key:"selectedInventoryReportsTab",value:2}
    },
    {
      type: "tab",
      name: "ASNs Details",
      chineseName:"ASNs 详情",
      key: "ASNsDetails",
      icon: <Icon fontSize="small">timeline</Icon>,
      route: "/report/inventory_reports?tab=5",
      parent:"Report - Inventory Reports",
      chineseNameParent:"报表 - 库存报表",
      localStorageKey:{key:"selectedInventoryReportsTab",value:3}
    },
    {
      type: "tab",
      name: "Aging",
      chineseName:"库存陈化",
      key: "aging",
      icon: <Icon fontSize="small">date_range</Icon>,
      route: "/report/inventory_reports?tab=6",
      parent:"Report - Inventory Reports",
      chineseNameParent:"报表 - 库存报表",
      localStorageKey:{key:"selectedInventoryReportsTab",value:4}
    },
    {
      type: "tab",
      name: "Expiry Date",
      chineseName:"过期时间",
      key: "expiryDate",
      icon: <Icon fontSize="small">event</Icon>,
      route: "/report/inventory_reports?tab=3",
      parent:"Report - Inventory Reports",
      chineseNameParent:"报表 - 库存报表",
      localStorageKey:{key:"selectedInventoryReportsTab",value:5}
    },
    {
      type: "tab",
      name: "Date",
      chineseName:"每日库存",
      key: "date",
      icon: <Icon fontSize="small">today</Icon>,
      route: "/report/inventory_reports?tab=2",
      parent:"Report - Inventory Reports",
      chineseNameParent:"报表 - 库存报表",
      localStorageKey:{key:"selectedInventoryReportsTab",value:6}
    },

    //price_setting
    ...(checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        ? [
          {
            type: "tab",
            name: "Section Of Commodity Size",
            chineseName:"商品尺寸分段",
            key: "commoditySize",
            icon: <Icon fontSize="small">straighten</Icon>,
            route: "/system/price_setting?tab=0",
            parent:"System - Price Setting",
            chineseNameParent:"系统设置 - 价格设置",
            localStorageKey:{key:"selectedPriceSettingTab",value:0}
          },
          {
            type: "tab",
            name: "Size Section Cost Setting",
            chineseName:"尺寸价格体系",
            key: "costSize",
            icon: <Icon fontSize="small">price_check</Icon>,
            route: "/system/price_setting?tab=1",
            parent:"System - Price Setting",
            chineseNameParent:"系统设置 - 价格设置",
            localStorageKey:{key:"selectedPriceSettingTab",value:1}
          },

        ]
        : []),
    //warehouse
    ...(checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        ? [
          {
            type: "tab",
            name: "Warehouse Settings",
            chineseName:"仓库设置",
            key: "warehouseSettings",
            icon: <Icon fontSize="small">warehouse</Icon>,
            route: "/system/warehouse?tab=0",
            parent:"System - Warehouse",
            chineseNameParent:"系统设置 - 仓库设置",
            localStorageKey:{key:"selectedWarehouseTab",value:0}
          },
          {
            type: "tab",
            name: "Warehouse Mappings",
            chineseName:"寻仓管理",
            key: "warehouseMappings",
            icon: <Icon fontSize="small">horizontal_split</Icon>,
            route: "/system/warehouse?tab=1",
            parent:"System - Warehouse",
            chineseNameParent:"系统设置 - 仓库设置",
            localStorageKey:{key:"selectedWarehouseTab",value:1}
          },

        ]
        : []),
    ...(!checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        ? [
          {
            type: "tab",
            name: "Oauth Credential",
            chineseName:"认证授权",
            key: "oauth_credential",
            icon: <Icon fontSize="small">warehouse</Icon>,
            route: "/system/developer?tab=0",
            parent:"Developer - Oauth Credential",
            chineseNameParent:"开发者 - 认证授权",
            localStorageKey:{key:"selectedDeveloperTab",value:0}
          },
          ...(checkPermission(PERMISSION_DICT.SystemWebhookList)
              ? [
                {
                  type: "tab",
                  name: "Webhooks",
                  chineseName:"回调路由",
                  key: "webhooks",
                  icon: <Icon fontSize="small">horizontal_split</Icon>,
                  route: "/system/developer?tab=1",
                  parent:"Developer - Webhooks",
                  chineseNameParent:"系统设置 - 回调路由",
                  localStorageKey:{key:"selectedDeveloperTab",value:1}
                },
              ]
              : [])
        ]
        : []),
  ]
}

export const emailValidation = (email) =>{
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const currencyList = [
  {
    id: 1,
    label: 'CAD',
    value: 'CAD',
  },
  {
    id: 2,
    label: 'USD',
    value: 'USD',
  },
]


export function getOrderStatusArr(t) {
  return [
    {
      id: 1,
      value: '0',
      label: t('Created'),
      color: 'primary',   // 灰
    },
    {
      id: 2,
      value: '10',
      label: t('Action Required'),
      color: 'error',     // 红
    },
    {
      id: 3,
      value: '20',
      label: t('Reviewing'),
      color: 'warning',   // 橙
    },
    {
      id: 4,
      value: '60',
      label: t('Ready for Fulfillment'),
      color: 'info',      // 蓝
    },
    {
      id: 5,
      value: '100',
      label: t('Completed'),
      color: 'success',   // 绿
    },
    {
      id: 6,
      value: '90',
      label: t('Cancelled'),
      color: 'gray',   // 灰
    },
    {
      id: 7,
      value: '110',
      label: t('Submit In Process'),
      color: 'medium', // 紫
    }
  ];
}

export function getInboundOrderStatusArr(t) {
  return [
    {
      id: 1,
      value: '0',
      label: t('Created'),
      color: 'default',   // 灰
    },
    {
      id: 2,
      value: '10',
      // label: t('Submitted')
      label: t('Action Required')
    },
    {
      id: 3,
      value: '20',
      label: t('Reviewing')
    },
    {
      id: 4,
      value: '60',
      // label: t('Notification to Storage')
      label: t('Warehouse Informed')
    },
    {
      id: 5,
      value: '100',
      label: t('Completed')
    },
    {
      id: 6,
      value: '90',
      label: t('Cancelled')
    },
    {
      id: 7,
      value: '110',
      label: t('Submit In Process')
    }
  ];
}

export function getTransferStatusArr(t) {
  return [
    // {
    //   id: 1,
    //   value: 0,
    //   label: t('TransferPage.Created')
    // },
    // {
    //   id: 2,
    //   value:1,
    //   label: t('TransferPage.Commit')
    // },
    // {
    //   id: 3,
    //   value: 20,
    //   label: t('TransferPage.First Approved')
    // },
    // {
    //   id: 4,
    //   value: 60,
    //   label: t('TransferPage.Second Approved')
    // },
    // {
    //   id: 4,
    //   value: 70,
    //   label: t('TransferPage.Third Approved')
    // },
    // {
    //   id: 4,
    //   value: 80,
    //   label: t('TransferPage.Fourth Approved')
    // },
    // {
    //   id: 5,
    //   value: 100,
    //   label: t('TransferPage.Notify Shipping')
    // },
    // {
    //   id: 6,
    //   value: 90,
    //   label: t('TransferPage.Cancelled')
    // },
    // // {
    // //   id: 7,
    // //   value: '110',
    // //   label: t('TransferPage.Submit In Process')
    // // }
    {
      id: 1,
      value: 0,
      label: t('Created')
    },
    {
      id: 2,
      value: 10,
      // label: t('Submitted')
      label: t('Action Required')
    },
    {
      id: 3,
      value: 20,
      label: t('Reviewing')
    },
    {
      id: 4,
      value: 60,
      // label: t('Notification to Storage')
      label: t('Warehouse Informed')
    },
    {
      id: 5,
      value: 100,
      label: t('Completed')
    },
    {
      id: 6,
      value: 90,
      label: t('Cancelled')
    },
    {
      id: 7,
      value: 110,
      label: t('Submit In Process')
    }
  ];
}

export const wmsProcessStateArr = [
  { id: 1, value: '00', label: 'Create SO' },
  // { id: 2, value: '10', label: 'Partially Soft Allocated' },
  // { id: 3, value: '20', label: 'Soft Allocated' },
  { id: 4, value: '30', label: 'Partially Allocated' },
  { id: 5, value: '40', label: 'Allocated' },
  // { id: 6, value: '50', label: 'Partially Picked' },
  { id: 7, value: '60', label: 'Picked' },
  // { id: 8, value: '61', label: 'Put-To-Store Completed' },
  // { id: 9, value: '62', label: 'Partially Cartonized' },
  { id: 10, value: '63', label: 'Cartonized' },
  // { id: 11, value: '65', label: 'Partially Loaded' },
  // { id: 12, value: '66', label: 'Loaded' },
  // { id: 13, value: '70', label: 'Partially Shipped' },
  // { id: 14, value: '80', label: 'Shipped' },
  // { id: 15, value: '90', label: 'Shipment Order Cancelled' },
  // { id: 16, value: '98', label: 'Hold' },
  { id: 17, value: '99', label: 'Completed' }
];

export const transferInvStatus = [
  { id: 1, value: 0, label:'Unallocated' },
  { id: 2, value: 10, label:'Allocated' },
  { id: 3, value: 20, label:'Partially Allocated' },
]

export function getTransferInvStatus(t) {
  return [
    { id: 1, value: 0, label: t('Unoccupied') },
    { id: 2, value: 10, label: t('Occupied') },
    { id: 3, value: 20, label: t('Partial Occupied') },
  ];
}

export function getTransferShipStatus(t) {
  return [
    { id: 1, value: 0, label: t('Not Shipped') },
    { id: 2, value: 10, label: t('Partially Shipped') },
    { id: 3, value: 20, label: t('Shipped') },
  ];
}

export function getTransferReceiveStatus(t) {
  return [
    { id: 1, value: 0, label: t('Not Received') },
    { id: 2, value: 10, label: t('Partially Received') },
    { id: 3, value: 20, label: t('Fully Received') },
  ];
}

export const asnWmsProcessStateArr = [
  { id: 1, value: '00', label: 'Order Created' },
  { id: 2, value: '05', label: 'Appointed' },
  { id: 3, value: '10', label: 'Palletized' },
  { id: 4, value: '30', label: 'Partially Received' },
  { id: 5, value: '40', label: 'Fully Received' },
  { id: 6, value: '90', label: 'ASN Cancelled' },
  { id: 7, value: '98', label: 'Hold' },
  { id: 8, value: '99', label: 'ASN Completed' },
];

export const wholesaleAdditionalRequire = [
  { id: 1, value: 'Packing List', label: 'Packing List' },
  { id: 2, value: 'Invoice', label: 'Invoice' },
  { id: 3, value: 'CHEP Pallet', label: 'CHEP Pallet' },
  { id: 4, value: 'Double Shrink Wrap', label: 'Double Shrink Wrap' },
  { id: 5, value: 'Pallet Edge Corner', label: 'Pallet Edge Corner' },
  { id: 6, value: 'Kitting', label: 'Kitting' },
  { id: 7, value: 'Appointment Needed', label: 'Appointment Needed' },
];


export const getTrackingLink = (carrierName, trackingNumber) => {

  if (!trackingNumber) return null;
  if (!carrierName) return null;
  let name = carrierName.trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "")

  // 如果包含下列carriers，则统一当成该carrier
  const carrierAliases = {
    uniuni: ["uniuni"],
    obibox: ["obibox"],
    fedex: ["fedex", "federalexpress"],
    canadapost: ["canadapost"],
    ups: ["ups"],
    purolator: ["purolator"],
    fleetoptics: ["fleetoptics"],
    canpar: ["canpar"],
    skip: ["skip"],
    dhl: ["dhl"],
    usps: ["usps"],
    ics: ["ics"],
    intelcom: ["intelcom"],
    aramex: ["aramex"],
    flashbox: ["flashbox"],
  };

  const matchedCarrier = Object.entries(carrierAliases).find(([, aliases]) =>
      aliases.some((alias) => name.includes(alias))
  );

  if (matchedCarrier) {
    name = matchedCarrier[0];
  }

  switch (name) {
    case 'uniuni':
      return `https://www.uniuni.com/tracking/?no=${trackingNumber}`;

    case 'obibox':
      return `https://tracking.obibox.io/${trackingNumber}`;

    case 'fedex':
      return `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`;

    case 'Canada Post':

    case 'canadapost':
      return `https://www.canadapost-postescanada.ca/track-reperage/en#/search?searchFor=${trackingNumber}`;

    case 'ups':
      return `https://www.ups.com/track?loc=en_CA&tracknum=${trackingNumber}`;

    case 'purolator':
      return `https://www.purolator.com/en/shipping/tracker?pins=${trackingNumber}`;

    case 'fleetoptics':
      return `https://track.fleetopticsinc.com/?tracking_number=${trackingNumber}`

    case "canpar":
      return `https://www.canpar.com/en/tracking/track.htm?barcode=${trackingNumber}`;

    case "skip":
      return `https://ww2.eshipper.com/track-shipment/r?trackingNumber=${trackingNumber}`;

    case "dhl":
      return `https://www.dhl.com/global-en/home/tracking.html?tracking-id=${trackingNumber}&submit=1`;

    case "usps":
      return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNumber}`;

    case "ics":
      return `https://www.icscourier.ca/online-services/parcel-tracking.aspx`;

    case "intelcom":
      return `https://intelcom.ca/en/track-your-package/?tracking-id=${trackingNumber}`;

    case "aramex":
      return `https://www.aramex.com/la/en/track/results?source=aramex&ShipmentNumber=${trackingNumber}`;

    case "flashbox":
      return `https://tracking.flashbox.co/`;
    default:
      return null;
  }
};




export const ticketTypeOptions = [
  { value: 1, label: 'SKU Issue', color: '#FDE68A' },
  { value: 2, label: 'Inbound Issue', color: '#FEF08A' },
  { value: 3, label: 'Outbound Issue', color: '#F59E0B' },
  { value: 4, label: 'Return Issue', color: '#C084FC' },
  { value: 5, label: 'Shipment Issue', color: '#BBF7D0' },
  { value: 6, label: 'Warehouse Issue', color: '#EF4444' },
  { value: 7, label: 'Others', color: '#BFDBFE' },
];




export const ticketStatusOptions = [
  { value: 10, label: 'Open', color: 'info' },
  { value: 15, label: 'In Progress', color: 'warning' },
  { value: 20, label: 'Pending', color: 'error' },
  { value: 35, label: 'Waiting for Customer', color: 'primary' },
  { value: 45, label: 'Waiting for Carrier', color: 'lightgrey' },
  { value: 25, label: 'Resolved', color: 'secondary' },
  { value: 30, label: 'Closed', color: 'success' },
  { value: 40, label: 'Reopen', color: 'info' },

];


export const ticketPriorityOptions = [
  { value: 1, label: 'Low', color: 'info' },
  { value: 2, label: 'Medium', color: 'medium' },
  { value: 3, label: 'High', color: 'warning' },
  { value: 4, label: 'Urgent', color: 'error' },
];


export const soOrderTypeMap = {
  1: 'Wholesale',
  2: 'E-Commerce',
};

export const ADMIN_OWNERS = {
    "rui-admin": [
        { ownerId: "352192556678", ownerName: "ChrisLogisticsQC" },
        { ownerId: "NS0052", ownerName: "ocp1030" },
        { ownerId: "OS1686", ownerName: "tasidiingold3" },
        { ownerId: "OS1676", ownerName: "ocp0911" },
    ],
    "dev-rui": [
        { ownerId: "OS1508", ownerName: "ChrisLogisticsQC" },
        { ownerId: "NS0052", ownerName: "ocp1030" },
        { ownerId: "OS1686", ownerName: "tasidiingold3" },
    ],
};


